import React from "react";


import NumberFormat from 'react-number-format';
import CurrencyInput from 'react-currency-input-field';


const Format = ({value, unit, editInputRow = '', rowPosition = '', position = '', onChange, displayType = 'input'}) => {

    const handleOnValueChange = (value, _, values) => {
        editInputRow(values.float, value, rowPosition, position)
    };

    const handleNumberFormat = (values) => {
        const {floatValue, formattedValue} = values
        editInputRow(floatValue,formattedValue, rowPosition, position)
    }

    const handlePercentFormat = (value, _, values) => {
        const newValue = (values.float / 100)
        editInputRow(newValue, value, rowPosition, position)
    }

    if (isNaN(value)) {

        let newValue = value;

        newValue = newValue.replaceAll('.', '')
        newValue = newValue.replaceAll(',', '.')

        if (isNaN(newValue)) {
            unit = 'text'
        } else {
            value = newValue
        }
    }

    switch (unit?.trim()) {
        case 'US$':
        case 'USD':
            return <NumberFormat
                        value={value}
                        thousandSeparator={true}
                        decimalScale={2}
                        decimalsLimit={2}
                        className="form-control form-control-sm border-0"
                        onValueChange={handleNumberFormat}
                        displayType={displayType}
                    />

        case 'R$':
        case 'BRL':
        case 't':
        case 'tCO₂e':
        case 'm³':
        case 'ha':
        case 'média':
        case 'GJ':
        case 'horas':
        case 'hours':
        case 'km²':
        case 'KG':
        case 'mg/L':
        case 'm³/t':
        case 'tCO₂e/R$':
        case 'GJ/t':
        case 'ML':
        case 'MWh':
        case 'MWm':
        case 'kg/t':
        case 'ac':
            return <CurrencyInput
                groupSeparator="."
                decimalSeparator=","
                value={value}
                defaultValue={value}
                decimalsLimit={2}
                decimalScale={2}
                className="form-control form-control-sm border-0"
                onValueChange={(value, _, values) => handleOnValueChange(value, _, values)}
                disabled={displayType === 'text'}
            />
        case 'tCO₂e/t':
            return <CurrencyInput
                        value={value}
                        defaultValue={value}
                        decimalsLimit={4}
                        groupSeparator="."
                        decimalSeparator=","
                        className="form-control form-control-sm border-0"
                        onValueChange={handleOnValueChange}
                        disabled={displayType === 'text'}
                    />

        case 'taxa':
        case 'rate':
            return <NumberFormat
                        fixedDecimalScale
                        thousandSeparator={'.'}
                        decimalSeparator={','}
                        decimalScale={2}
                        decimalsLimit={2}
                        suffix={'%'}
                        className="form-control form-control-sm border-0"
                        value={value * 100}
                        onValueChange={handleNumberFormat}
                        displayType={displayType}
                    />

        case 'número total':
        case 'overall number':
            return <NumberFormat
                        thousandSeparator={'.'}
                        decimalSeparator={','}
                        className="form-control form-control-sm border-0"
                        value={value}
                        onValueChange={handleNumberFormat}
                        displayType={displayType}
                    />

        case '%':
            return <CurrencyInput
                value={value}
                        defaultValue={value}
                        decimalsLimit={2}
                        decimalScale={2}
                        groupSeparator="."
                        decimalSeparator=","
                        suffix={'%'}
                        className="form-control form-control-sm border-0"
                        onValueChange={handleOnValueChange}
                        disabled={displayType === 'text'}
                    />
        case 'text':
        case 'string':
            return displayType !== 'text' ? <input
                className="form-control form-control-sm border-0"
                value={value}
                onChange={(e) => editInputRow(e.target.value, '', rowPosition, position)}
            /> : value
        case 'mil':
            return <CurrencyInput
                value={value}
                defaultValue={value}
                decimalsLimit={3}
                groupSeparator="."
                decimalSeparator=","
                className="form-control form-control-sm border-0"
                onValueChange={handleOnValueChange}
                disabled={displayType === 'text'}
            />

        default:
            return displayType !== 'text' ? <textarea
                className="form-control form-control-sm border-0"
                value={value}
                rows="1"
                onChange={(e) => editInputRow(e.target.value, '', rowPosition, position)}
            /> : value
    }
}
 export default Format
